<div class="notification-container">
  @for (notification of notifications(); track notification.id) {
    <div class="notification notification-{{ notification.type }}">
      <div class="notification-icon">
        <fa-icon [icon]="getIcon(notification.type)" size="lg"></fa-icon>
      </div>
      <div class="notification-content">
        <h4 class="notification-title">{{ notification.title }}</h4>
        @if (notification.message) {
          <p class="notification-message">{{ notification.message }}</p>
        }
      </div>
      <button class="notification-close" (click)="close(notification.id)" type="button">
        <fa-icon [icon]="icons.close"></fa-icon>
      </button>
    </div>
  }
</div>
